'use client'

import { useEffect } from 'react'

// Next reemplaza el título por el de su metadata tras cada navegación; se vuelve a poner si otro lo cambia.
export const usePageTitle = (title: string) => {
  useEffect(() => {
    const applyTitle = () => {
      if (document.title !== title) document.title = title
    }

    applyTitle()

    const observer = new MutationObserver(applyTitle)

    observer.observe(document.head, { childList: true, subtree: true, characterData: true })

    return () => observer.disconnect()
  }, [title])
}
